var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[(!_vm.isPE)?_c('PageHeader'):_vm._e(),(_vm.isPE)?_c('PEHeader'):_vm._e(),_c('div',{style:('top:' + this.myTop),attrs:{"id":"main"}},[_c('router-view',{attrs:{"id":"rv"}},[_vm._v("获取信息失败")])],1),_c('PageFooter',{attrs:{"bgc":this.footerBgc}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }